var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 12,
    viewBox: "0 0 29 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 17",
    d: "M29 6L23 11.1962L23 0.803848L29 6Z",
    fill: "#D70027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 18",
    opacity: 0.5,
    d: "M19 6L13 11.1962L13 0.803848L19 6Z",
    fill: "#D70027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 19",
    opacity: 0.1,
    d: "M8 6L2 11.1962L2 0.803848L8 6Z",
    fill: "#D70027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIcon);
export default __webpack_public_path__ + "static/media/arrowsIcon.0ac3af8fa94967b441f0988da22940e0.svg";
export { ForwardRef as ReactComponent };